const AtribuitionsTexts = {
  trybept: {
    logo: '/Trybe-logo.jpg',
    title: 'Desenvolvimento full-stack',
    text: 'Trybe Escola de Programação',
    date: 'Abr de 2023 - Ago de 2024',
  },
  trybeeng: {
    logo: '/Trybe-logo.jpg',
    title: 'Full-Stack Development',
    text: 'Trybe Programming School',
    date: 'Apr 2023 - Aug 2024',
  },
  anhembipt: {
    logo: '/Anhembi-logo.png',
    title: 'Bacharelado em Publicidade',
    text: 'Universidade Anhembi Morumbi',
    date: 'Maio de 2010 - Maio de 2014',
  },
  anhembieng: {
    logo: '/Anhembi-logo.png',
    title: 'Bachelor in Advertising',
    text: 'Anhembi Morumbi University',
    date: 'May 2010 - May 2014',
  },
  englishpt: {
    logo: '/english-logo.png',
    title: 'Língua Inglesa',
    text: 'Nível avançado',
    date: '',
  },
  englisheng: {
    logo: '/english-logo.png',
    title: 'English Language',
    text: 'Advanced level',
    date: '',
  },
  fullstackpt: {
    logo: '/Trybe-logo.jpg',
    title: 'Desenvolvimento Full-Stack',
    text: 'Trybe',
    certificate: '/fullstack-certificate.png',
    link: 'https://www.credential.net/d9b8dc29-b77e-4093-9e90-a7b98f0b8222#gs.e6jp1o',
    pdf: '/fullstack.pdf',
  },
  fullstackeng: {
    logo: '/Trybe-logo.jpg',
    title: 'Full-Stack Development',
    text: 'Trybe',
    certificate: '/backend-certificate.png',
    link: 'https://www.credential.net/16f06b72-fbca-41c2-a957-ed3e045b0175',
    pdf: '/backend.pdf',
  },
  java: {
    logo: '/Trybe-logo.jpg',
    title: 'Java',
    text: 'Trybe',
    certificate: '/java.png',
    link: 'https://www.credential.net/84b14ba0-ccc5-449c-a615-29d7c3dd16d8',
    pdf: '/java.pdf',
  },
  backendpt: {
    logo: '/Trybe-logo.jpg',
    title: 'Desenvolvimento Back-End',
    text: 'Trybe',
    certificate: '/backend-certificate.png',
    link: 'https://www.credential.net/16f06b72-fbca-41c2-a957-ed3e045b0175',
    pdf: '/backend.pdf',
  },
  backendeng: {
    logo: '/Trybe-logo.jpg',
    title: 'Back-End Development',
    text: 'Trybe',
    certificate: '/backend-certificate.png',
    link: 'https://www.credential.net/16f06b72-fbca-41c2-a957-ed3e045b0175',
    pdf: '/backend.pdf',
  },
  frontendpt: {
    logo: '/Trybe-logo.jpg',
    title: 'Desenvolvimento Front-End',
    text: 'Trybe',
    certificate: '/frontend-certificate.png',
    link: 'https://www.credential.net/bd632c60-e956-4054-9bb9-41c1c8474d04#gs.cq2kpw',
    pdf: '/frontend.pdf',
  },
  frontendeng: {
    logo: '/Trybe-logo.jpg',
    title: 'Front-End Development',
    text: 'Trybe',
    certificate: '/frontend-certificate.png',
    link: 'https://www.credential.net/bd632c60-e956-4054-9bb9-41c1c8474d04#gs.cq2kpw',
    pdf: '/frontend.pdf',
  },
  pcsciencept: {
    logo: '/Trybe-logo.jpg',
    title: 'Ciência da Computação',
    text: 'Trybe',
    certificate: '/pcscience-certificate.png',
    link: 'https://www.credential.net/75d945ec-7455-41a6-b1b4-a3df76bb6ac7#gs.cq7uyc',
    pdf: '/computerscience.pdf',
  },
  pcscienceeng: {
    logo: '/Trybe-logo.jpg',
    title: 'Computer Science',
    text: 'Trybe',
    certificate: '/pcscience-certificate.png',
    link: 'https://www.credential.net/75d945ec-7455-41a6-b1b4-a3df76bb6ac7#gs.cq7uyc',
    pdf: '/computerscience.pdf',
  },
};

export default AtribuitionsTexts;
